var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInfo = function SvgInfo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 245,
    height: 171,
    viewBox: "0 0 245 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M236.298 0H8.24667C3.69216 0 0 3.69216 0 8.24667V162.068C0 166.623 3.69216 170.315 8.24667 170.315H236.298C240.853 170.315 244.545 166.623 244.545 162.068V8.24667C244.545 3.69216 240.853 0 236.298 0Z",
    fill: "#331338"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1648_281902)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.31055,
    y: 8.99609,
    width: 227.646,
    height: 152.334,
    rx: 4.10789,
    fill: "#F4FAFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.3394,
    height: 10.9259,
    rx: 5.46294,
    transform: "matrix(-0.720625 -0.693325 -0.693325 0.720625 47.1582 182.344)",
    fill: "#E1BEE7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.3394,
    height: 10.9259,
    rx: 5.46295,
    transform: "matrix(0.720625 0.693325 0.693325 -0.720625 21.2402 146.488)",
    fill: "#E1BEE7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6094 96.0099C43.3104 94.8998 42.6766 93.0593 43.4549 91.5381L45.5082 87.5249C46.287 86.0026 48.1674 85.3838 49.5734 86.3571C51.2361 87.5082 52.7458 88.873 54.0623 90.4197C56.0495 92.7542 57.5573 95.4573 58.4998 98.3745C59.4423 101.292 59.801 104.366 59.5553 107.422C59.3097 110.478 58.4646 113.455 57.0682 116.185C55.6718 118.914 53.7515 121.342 51.417 123.329C49.0825 125.316 46.3794 126.824 43.4621 127.766C40.5449 128.709 37.4705 129.067 34.4147 128.822C32.3901 128.659 30.4 128.233 28.4937 127.558C26.8817 126.987 26.2833 125.1 27.0622 123.578L28.5544 120.662C29.3327 119.14 31.1961 118.578 32.8564 118.981C33.5359 119.147 34.229 119.259 34.9293 119.315C36.6655 119.454 38.4123 119.251 40.0698 118.715C41.7273 118.18 43.2631 117.323 44.5895 116.194C45.9159 115.065 47.0069 113.686 47.8003 112.135C48.5937 110.584 49.0739 108.892 49.2135 107.156C49.353 105.42 49.1492 103.673 48.6137 102.016C48.0782 100.358 47.2215 98.8224 46.0925 97.496C45.6371 96.961 45.141 96.4642 44.6094 96.0099Z",
    fill: "#B2EBF2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.251 15.8116C172.952 14.7014 172.319 12.8611 173.097 11.34L175.151 7.32565C175.93 5.80334 177.81 5.18458 179.216 6.15792C180.879 7.30902 182.388 8.67382 183.705 10.2204C185.692 12.555 187.2 15.258 188.142 18.1753C189.085 21.0926 189.444 24.1669 189.198 27.2228C188.952 30.2787 188.107 33.2563 186.711 35.9855C185.314 38.7148 183.394 41.1423 181.06 43.1294C178.725 45.1166 176.022 46.6244 173.105 47.5669C170.187 48.5094 167.113 48.8681 164.057 48.6224C162.033 48.4597 160.043 48.0338 158.136 47.3589C156.524 46.7882 155.926 44.9012 156.705 43.3789L158.197 40.4628C158.975 38.9418 160.838 38.3789 162.498 38.7826C163.177 38.9477 163.87 39.0593 164.57 39.1156C166.306 39.2552 168.053 39.0514 169.71 38.5159C171.368 37.9804 172.904 37.1237 174.23 35.9946C175.557 34.8656 176.648 33.4864 177.441 31.9357C178.234 30.385 178.715 28.6932 178.854 26.957C178.994 25.2207 178.79 23.474 178.254 21.8165C177.719 20.1589 176.862 18.6231 175.733 17.2967C175.278 16.7621 174.782 16.2657 174.251 15.8116Z",
    fill: "#FFCCBC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.1406,
    y: 82.3828,
    width: 43.5341,
    height: 10.975,
    rx: 5.48749,
    transform: "rotate(-115.532 30.1406 82.3828)",
    fill: "#FFCCBC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.86523,
    y: 64.8633,
    width: 43.5341,
    height: 10.975,
    rx: 5.48749,
    transform: "rotate(-25.5324 3.86523 64.8633)",
    fill: "#FFCCBC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.484,
    y: 94.1211,
    width: 43.5341,
    height: 10.975,
    rx: 5.48749,
    transform: "rotate(-115.532 134.484 94.1211)",
    fill: "#E1BEE7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.209,
    y: 76.6016,
    width: 43.5341,
    height: 10.975,
    rx: 5.48749,
    transform: "rotate(-25.5324 108.209 76.6016)",
    fill: "#E1BEE7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.719,
    y: 117.625,
    width: 43.5341,
    height: 10.975,
    rx: 5.48749,
    transform: "rotate(-142.439 105.719 117.625)",
    fill: "#FFE0B2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.13443,
    cy: 5.13443,
    r: 5.13443,
    transform: "matrix(0.787632 0.616146 0.616146 -0.787632 95.6992 156.234)",
    fill: "#FFCCBC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.13443,
    cy: 5.13443,
    r: 5.13443,
    transform: "matrix(0.787632 0.616146 0.616146 -0.787632 71.5762 137.363)",
    fill: "#FFCCBC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.703,
    y: 131.996,
    width: 43.5341,
    height: 10.975,
    rx: 5.48749,
    transform: "rotate(128.035 108.703 131.996)",
    fill: "#FFCCBC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.13443,
    cy: 5.13443,
    r: 5.13443,
    transform: "matrix(0.787632 0.616146 0.616146 -0.787632 127.283 16.0078)",
    fill: "#FFE0B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.287,
    y: -8.23047,
    width: 43.5341,
    height: 10.975,
    rx: 5.48749,
    transform: "rotate(128.035 140.287 -8.23047)",
    fill: "#FFE0B2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.13443,
    cy: 5.13443,
    r: 5.13443,
    transform: "matrix(0.949569 -0.313557 -0.313557 -0.949569 192.461 84.8125)",
    fill: "#FFE0B2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.13443,
    cy: 5.13443,
    r: 5.13443,
    transform: "matrix(0.949569 -0.313557 -0.313557 -0.949569 163.379 94.418)",
    fill: "#FFE0B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.508,
    y: 60.5469,
    width: 43.5341,
    height: 10.975,
    rx: 5.48749,
    transform: "rotate(71.7263 179.508 60.5469)",
    fill: "#FFE0B2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.13443,
    cy: 5.13443,
    r: 5.13443,
    transform: "matrix(0.949569 -0.313557 -0.313557 -0.949569 3.78516 113.09)",
    fill: "#FFE0B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.12 132.711C140.192 134.418 139.275 136.135 137.631 136.601L133.293 137.83C131.648 138.296 129.914 137.341 129.67 135.648C129.381 133.647 129.352 131.612 129.588 129.594C129.945 126.55 130.898 123.605 132.393 120.928C133.888 118.251 135.895 115.895 138.3 113.994C140.705 112.094 143.462 110.685 146.411 109.849C149.361 109.014 152.446 108.767 155.491 109.124C158.536 109.48 161.481 110.433 164.158 111.928C166.834 113.423 169.19 115.43 171.091 117.835C172.35 119.429 173.394 121.176 174.197 123.032C174.877 124.601 173.902 126.324 172.257 126.791L169.106 127.683C167.462 128.149 165.781 127.168 164.946 125.677C164.605 125.067 164.215 124.484 163.779 123.933C162.699 122.566 161.361 121.426 159.84 120.577C158.319 119.727 156.646 119.186 154.916 118.983C153.186 118.781 151.433 118.921 149.757 119.396C148.081 119.87 146.515 120.671 145.148 121.751C143.782 122.831 142.641 124.169 141.792 125.69C140.943 127.211 140.401 128.884 140.199 130.614C140.117 131.312 140.091 132.013 140.12 132.711Z",
    fill: "#B2EBF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.484,
    y: 134.398,
    width: 43.5341,
    height: 10.975,
    rx: 5.48749,
    transform: "rotate(156.601 225.484 134.398)",
    fill: "#E1BEE7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.6387,
    y: 30.6562,
    width: 43.5341,
    height: 10.975,
    rx: 5.48749,
    transform: "rotate(-137.953 48.6387 30.6562)",
    fill: "#FFCCBC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.236,
    y: 186.363,
    width: 43.5341,
    height: 10.975,
    rx: 5.48749,
    transform: "rotate(-69.3794 141.236 186.363)",
    fill: "#FFE0B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.67,
    y: 155.277,
    width: 43.5341,
    height: 10.975,
    rx: 5.48749,
    transform: "rotate(20.6206 135.67 155.277)",
    fill: "#FFE0B2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.3394,
    height: 10.9259,
    rx: 5.46294,
    transform: "matrix(0.333413 -0.942781 -0.942781 -0.333413 70.7617 64.8945)",
    fill: "#B2EBF2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.3394,
    height: 10.9259,
    rx: 5.46294,
    transform: "matrix(-0.333413 0.942781 0.942781 0.333413 92.6953 26.4727)",
    fill: "#B2EBF2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.3394,
    height: 10.9259,
    rx: 5.46295,
    transform: "matrix(-0.452365 -0.891833 -0.891833 0.452365 234.26 78.6172)",
    fill: "#B2EBF2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.3394,
    height: 10.9259,
    rx: 5.46295,
    transform: "matrix(0.452365 0.891833 0.891833 -0.452365 221.582 36.2344)",
    fill: "#B2EBF2"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 200.012,
    cy: 125.901,
    r: 31.3227,
    fill: "#49B4E2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.459,
    y: 121.129,
    width: 37.1313,
    height: 9.36083,
    rx: 4.68042,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.602,
    y: 107.348,
    width: 37.1313,
    height: 9.36083,
    rx: 4.68042,
    transform: "rotate(90 204.602 107.348)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.502 120.721L92.8464 115.102L104.431 116.693C105.349 116.819 106.251 117.037 107.126 117.342L146.497 131.093L171.233 127.71L177.266 130.21C177.438 134.131 174.809 137.624 170.994 138.544L144.801 144.858L103.14 129.88C98.9651 128.379 95.7562 124.977 94.502 120.721Z",
    fill: "#FFA726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8457 115.102L94.5013 120.72C95.7554 124.976 98.9644 128.379 103.14 129.88L139.922 143.104C143.111 144.251 146.556 144.489 149.872 143.792L173.039 138.926C175.267 138.458 177.035 136.763 177.598 134.557V134.557C178.678 130.323 174.994 126.4 170.7 127.213L168.043 127.716L151.882 130.887C149.142 131.425 146.316 131.328 143.619 130.604L112.834 122.343C108.372 121.145 104.796 117.812 103.288 113.445L103.227 113.268",
    stroke: "#DF8603",
    strokeWidth: 3.09176,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4905 76.6092C49.0488 51.0575 74.2684 34.8497 99.8201 40.408C125.372 45.9663 141.58 71.1859 136.021 96.7376L119.83 171.17C118.898 175.454 115.085 178.515 110.702 178.411C81.1983 177.713 61.9631 173.743 32.6579 161.395C28.5962 159.684 26.373 155.298 27.3099 150.992L43.4905 76.6092Z",
    fill: "#FFA726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.312 71.7109C101.703 78.7891 101.221 82.9635 99.006 90.8095",
    stroke: "black",
    strokeWidth: 5.66824,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6387 69.7852C89.248 76.8897 88.7704 81.0646 86.3321 88.8837",
    stroke: "black",
    strokeWidth: 5.66824,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.044 106.139L139.226 91.5071C144.999 64.9558 128.156 38.7513 101.605 32.9776V32.9776C75.0534 27.2039 48.8488 44.0475 43.0751 70.5988L39.8934 85.2304",
    stroke: "black",
    strokeWidth: 3.56513
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0713 69.6063C33.4478 67.8747 35.1568 66.7763 36.8884 67.1528L44.901 68.8952L38.6891 97.4617L30.6765 95.7193C28.9449 95.3428 27.8464 93.6338 28.223 91.9022L33.0713 69.6063Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.713027
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.81 117.034C143.433 118.766 141.724 119.864 139.992 119.488L131.98 117.745L138.192 89.179L146.204 90.9213C147.936 91.2979 149.034 93.0069 148.658 94.7385L143.81 117.034Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.713027
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4515 94.4351L57.6862 95.5289L57.1758 97.9717L56.5925 100.764L51.7797 99.3937L52.0954 97.0633L52.4515 94.4351Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5547 85.9609C44.4189 94.3288 45.802 96.3362 57.1758 97.9717M52.4515 94.4351L57.6862 95.5289L56.5925 100.764L51.7797 99.3937L52.4515 94.4351Z",
    stroke: "black",
    strokeWidth: 2.13908
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3743 129.629C52.7806 143.393 73.9253 146.765 90.6347 145.51C92.536 145.368 94.1632 144.129 94.8931 142.368V142.368C96.322 138.919 93.7868 135.109 90.0622 134.864C75.0758 133.876 57.3682 129.973 47.7624 120.88",
    stroke: "#DF8603",
    strokeWidth: 3.00416,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1611 107.289C86.2189 101.757 80.6358 97.2861 72.9423 87.446C72.4161 86.7731 71.4108 86.7076 70.8613 87.3616C64.0968 95.4126 64.3025 107.522 75.6903 114.107C85.3256 119.678 93.6486 112.374 96.5276 109.315C97.1184 108.687 96.9145 107.708 96.1611 107.289Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3597 112.575C74.2448 111.128 74.8059 109.434 74.9272 107.601C75.291 102.103 71.5678 97.3272 66.4783 96.5399C65.5654 102.259 67.5716 108.259 73.3597 112.575Z",
    fill: "#F48FB1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1648_281902"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.31055,
    y: 8.99609,
    width: 227.646,
    height: 152.334,
    rx: 4.10789,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "info.b7173edd043179714b7d1f448f5cae1a.svg";